module.exports = __webpack_public_path__ + "static/media/history_image6.742e86a2.jpg";